import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Collapse from '@material-ui/core/Collapse';
import SwitchWithLabel from '../../../common/CustomSwitch';
import CustomTextField from '../../../common/CustomTextField';
import { MAX_VALUE_CONSTRAINTS, MIN_VALUE } from '../../../common/constants';
import { PHYSICAL_PIECES } from '../../../../constants';

const styles = (theme: any) => ({
  physicalPiecesInput: { width: '35%' },
  physicalPiecesInfo: {
    color: theme.TextColor,
    fontSize: theme.textFontSize,
    opacity: 0.8,
  },
});

type EditInfo = {
  isPhysicalPiecesChanged: boolean;
  physicalPiecesHandled?: string | number | null;
};

type ErrorInfo = {
  physicalPiecesHandled?: unknown;
};

type HandleChange = (field: string) => (value: unknown) => void;

type PhysicalPiecesProps = {
  classes: Record<string, string>;
  errorInfo: ErrorInfo;
  editInfo: EditInfo;
  handleChange: HandleChange;
};

const PhysicalPieces: React.FC<PhysicalPiecesProps> = ({
  classes,
  errorInfo,
  editInfo,
  handleChange
}) => {
  const handlePhysicalPiecesCount = (value: unknown) => {
    handleChange('physicalPiecesHandled')(value);
  };

  return (
    <>
      <SwitchWithLabel
        rowLabel={PHYSICAL_PIECES.CHANGE_IN_PHYSICAL_PIECES_ROW_LABEL}
        onChange={handleChange('isPhysicalPiecesChanged')}
        value={editInfo.isPhysicalPiecesChanged}
      />
      <span className={classes.physicalPiecesInfo}>
        {PHYSICAL_PIECES.PHYSICAL_PIECES_INFO_LABEL}
      </span>
      <Collapse in={editInfo.isPhysicalPiecesChanged} timeout="auto" unmountOnExit>
        <CustomTextField
          id="physicalPiecesHandled"
          label={PHYSICAL_PIECES.PHYSICAL_PIECES_INPUT_LABEL}
          handleChange={handlePhysicalPiecesCount}
          error={errorInfo.physicalPiecesHandled}
          value={editInfo.physicalPiecesHandled}
          className={classes.physicalPiecesInput}
          type="number"
          inputProps={{
            max: MAX_VALUE_CONSTRAINTS.DELIVERY_PRO_FORM.PHYSICAL_PIECES,
            focused: true,
            min: MIN_VALUE.DEFAULT,
          }}
        />
      </Collapse>
    </>
  );
};

export default withStyles(styles)(PhysicalPieces);
